import React, { useState, useEffect } from "react";
import logo from "../img/enjuggernaut_logo.png";
import mail from "../img/mail.svg";
import career_mirror from "../img/career_mirror.svg";
import analysis from "../img/analysis.svg";
import portfolio_update from "../img/portfolio_update.svg";
import sample_resume from "../img/Alex_Smith_Resume.png";
import sample_resume_score from "../img/score.png";
import sample_resume_relevance from "../img/relevance.png";
import "../Common.css";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { AppState } from "../store";
import { useAuthToken } from "../AuthProvider";
import add_document from "../img/add_document.svg";

function Home() {
  const navigate = useNavigate();
  const { isAuthenticated, token, updateToken } = useAuthToken();
  const [typedText, setTypedText] = useState("");
  const [showCursor, setShowCursor] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const text = " future.";

  const navigateToStart = () => {
    navigate("/start");
  };

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const maillink = "mailto:support@enjuggernaut.com";

  useEffect(() => {
    let index = 0;
    const intervalId = setInterval(() => {
      if (index <= text.length) {
        setTypedText(text.slice(0, index));
        index++;
      } else {
        setShowCursor(false);
        clearInterval(intervalId);
      }
    }, 150);

    setShowCursor(true);

    return () => clearInterval(intervalId);
  }, [text]);

  return (
    <div className="light-panel min-h-screen">
      <header className="header dark-panel sticky top-0 z-50 mx-auto flex flex-row items-center justify-between p-4">
        <div className="justify-left">
          <a
            onClick={() =>
              document
                .querySelector("#main")
                ?.scrollIntoView({ behavior: "smooth" })
            }
          >
            <img src={logo} className="h-auto w-1/2" alt="logo" />
          </a>
        </div>

        <div className="justify-right hidden items-center md:flex">
          {isAuthenticated && (
            <button
              className="login-button mr-4 whitespace-nowrap px-4 py-2 font-bold md:py-3 md:text-lg lg:mr-10 lg:text-xl xl:text-2xl 2xl:text-3xl"
              onClick={() => {
                updateToken("");
              }}
            >
              Log Out
            </button>
          )}

          {!isAuthenticated && (
            <button
              className="login-button mr-4 whitespace-nowrap px-4 py-2 font-bold md:py-3 md:text-lg lg:mr-10 lg:text-xl xl:text-2xl 2xl:text-3xl"
              onClick={() => navigate("/login")}
            >
              Log In
            </button>
          )}

          {isAuthenticated && (
            <button
              className="start-button whitespace-nowrap px-4 py-2 font-bold md:py-3 md:text-lg lg:text-xl xl:text-2xl 2xl:text-3xl"
              onClick={() => navigate("/resumes")}
            >
              My Account
            </button>
          )}

          {!isAuthenticated && (
            <button
              className="start-button whitespace-nowrap px-4 py-2 font-bold md:py-3 md:text-lg lg:text-xl xl:text-2xl 2xl:text-3xl"
              onClick={navigateToStart}
            >
              Get Started!
            </button>
          )}
        </div>

        <div className="md:hidden">
          <button
            onClick={toggleMenu}
            className="text-white hover:text-gray-300 focus:outline-none"
          >
            <svg
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              viewBox="0 0 24 24"
              stroke="currentColor"
              className="h-6 w-6"
            >
              {isOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16M4 18h16"
                />
              )}
            </svg>
          </button>
        </div>
      </header>

      {isOpen && (
        <div className="header dark-panel fixed z-30 flex w-screen flex-col space-y-8 rounded p-4 shadow md:hidden">
          {isAuthenticated && (
            <button
              className="login-button whitespace-nowrap py-2 font-bold  md:py-3 md:text-lg lg:text-xl xl:text-2xl 2xl:text-3xl"
              onClick={() => {
                updateToken("");
              }}
            >
              Log Out
            </button>
          )}

          {!isAuthenticated && (
            <button
              className="login-button whitespace-nowrap py-2 font-bold md:py-3 md:text-lg lg:text-xl xl:text-2xl 2xl:text-3xl"
              onClick={() => navigate("/login")}
            >
              Log In
            </button>
          )}

          {isAuthenticated && (
            <button
              className="start-button whitespace-nowrap py-2 font-bold md:py-3 md:text-lg lg:text-xl xl:text-2xl 2xl:text-3xl"
              onClick={() => navigate("/resumes")}
            >
              My Account
            </button>
          )}

          {!isAuthenticated && (
            <button
              className="start-button py-2 font-bold md:py-3 md:text-lg lg:text-xl xl:text-2xl 2xl:text-3xl"
              onClick={navigateToStart}
            >
              Get Started!
            </button>
          )}
        </div>
      )}

      <button onClick={navigateToStart}>
        <div className="fixed bottom-5 right-5 z-50 flex h-16 w-16 items-center justify-center rounded-full bg-[#ff8800] shadow-lg md:hidden">
          <img src={add_document} />
        </div>
      </button>

      <section
        id="main"
        className="lg:px-30 z-20 inline-flex h-auto w-full flex-col px-10 md:px-20 xl:px-40 2xl:px-80"
      >
        <div className="z-20 w-full">
          <h1 className="welcome-text pt-8 text-3xl font-bold md:text-4xl lg:text-5xl xl:pt-14 xl:text-6xl 2xl:text-7xl">
            <span className="text-orange">Reinventing </span>
            <span className="text-blue">you </span>
            <span>to </span>
          </h1>

          <h1 className="welcome-text pt-8 text-3xl font-bold md:text-4xl lg:text-5xl xl:pt-14 xl:text-6xl 2xl:text-7xl">
            <span className="text-orange">Reinvent </span>
            <span>the </span>
            <span className="text-blue">
              {typedText} {showCursor && "|"}
            </span>
          </h1>

          <h2 className="welcome-subtext w-4/5 font-code text-base md:w-2/3 lg:text-lg xl:text-xl">
            <span className="text-orange font-bold">en</span>
            <span className="text-blue font-bold">juggernaut</span>
            <span>
              &nbsp;is an online platform that will take your software
              engineering career to the next level.{" "}
              <span className="text-blue font-bold italic">Powered by AI.</span>
            </span>
          </h2>
        </div>

        <div id="example_profile" className="relative z-10 mt-10 h-auto w-full">
          <div className="dark-panel relative z-20 h-auto w-full shadow-[0_10px_100px_-2px_rgba(0,0,0,0.3)] lg:py-10">
            <img
              src={sample_resume}
              alt="Sample Resume"
              className="mx-auto blur-[2px]"
            />
          </div>

          <div className="absolute top-1/4 z-30 pt-28 md:pt-14 lg:-left-28 lg:scale-75 lg:pt-0 lg:shadow-[0_10px_100px_-2px_rgba(0,0,0,0.3)] xl:left-0 xl:scale-75">
            <img
              src={sample_resume_score}
              alt="Sample Resume Score"
              className="z-40"
            />
          </div>

          <div className="collapse absolute bottom-10 z-30 shadow-[0_10px_100px_-2px_rgba(0,0,0,0.3)] md:scale-50 lg:visible lg:-right-48 lg:bottom-0 lg:scale-75 xl:right-0 xl:scale-75">
            <img
              src={sample_resume_relevance}
              alt="Sample Resume Relevance"
              className="z-40 "
            />
          </div>
        </div>
      </section>

      <section
        id="learn_more"
        className="dark-panel lg:px-50 mt-20 min-h-screen px-10 md:px-40 xl:px-60 2xl:px-80"
      >
        <div className="grid grid-cols-2 gap-2 lg:grid-cols-4">
          <div className="col-span-2">
            <p>&nbsp;</p>
            <hr className="border-blue ml-2 mr-auto mt-5 w-1/2 border-4" />
            <hr className="border-blue ml-2 mr-auto w-1/2 border-2" />

            <p className="ml-2 pt-2 font-code text-xl font-bold text-white md:text-2xl lg:text-3xl xl:text-4xl 2xl:text-5xl">
              Harness <span className="text-blue font-bold">AI</span>, get{" "}
              <span className="text-orange font-bold">hired</span>.
            </p>

            <div className="relative mt-10 flex h-fit w-full flex-row justify-start">
              <div className="blue-line absolute inline-block h-full min-h-[1em] w-0.5 self-stretch opacity-100" />

              <div className="flex w-full flex-col">
                <h3 className="w-full pl-2 text-left font-code text-white md:text-lg lg:text-xl xl:text-2xl">
                  Identify strong and weak points in seconds by uploading your
                  existing resume. We&apos;ll take it from there.
                </h3>
              </div>
            </div>
          </div>

          <div className="col-span-2">
            <img
              src={career_mirror}
              alt="Man looking at professional self in mirror"
              className="mt-4 scale-90 lg:mt-8 xl:mt-16"
            />
          </div>

          <div className="col-span-2 hidden lg:flex">
            <img
              src={portfolio_update}
              alt="Woman replacing old experience with new, improved experience"
              className="mt-4 scale-90 lg:mt-8 xl:mt-16"
            />
          </div>

          <div className="col-span-2">
            <p>&nbsp;</p>
            <hr className="border-blue ml-auto mt-5 w-1/2 border-4" />
            <hr className="border-blue ml-auto w-1/2 border-2" />

            <p className="pt-2 text-right font-code text-xl font-bold text-white md:text-2xl lg:text-3xl xl:text-4xl 2xl:text-5xl">
              No fake info. Ever.
            </p>

            <div className="relative mt-10 flex h-fit flex-row justify-end">
              <div className="flex flex-col">
                <h3 className="pr-2 text-right font-code text-white md:text-lg lg:text-xl xl:text-2xl">
                  Your resume has to be yours. Our AI will ask you questions
                  about your resume to fill in the gaps. Then, we&apos;ll write
                  you a new draft in minutes.
                </h3>
              </div>

              <div className="blue-line absolute inline-block h-full min-h-[1em] w-0.5 self-stretch opacity-100" />
            </div>
          </div>

          <div className="col-span-2 flex lg:hidden">
            <img
              src={portfolio_update}
              alt="Man looking at analysis of resume"
              className="mt-4 scale-90 lg:mt-8 xl:mt-16"
            />
          </div>

          <div className="col-span-2">
            <p>&nbsp;</p>
            <hr className="border-orange ml-2 mt-5 w-1/2 border-4" />
            <hr className="border-orange ml-2 w-1/2 border-2" />

            <p className="text-light ml-2 pt-2 font-code text-xl font-bold md:text-2xl lg:text-3xl xl:text-4xl 2xl:text-5xl">
              <span className="font-bold text-white">Beat the ATS.</span>
            </p>

            <div className="relative mt-10 flex h-fit flex-col">
              <div className="orange-line absolute inline-block h-full min-h-[1em] w-0.5 self-stretch opacity-100" />

              <h3 className="pl-2 font-code text-white md:text-lg lg:text-xl xl:text-2xl">
                Pit our AI against theirs by pasting a job description and
                picking your best draft. We can write a custom-tailored version
                for the job, too.
              </h3>
            </div>
          </div>

          <div className="col-span-2">
            <img src={analysis} className="mt-4 scale-90 lg:mt-8 xl:mt-16" />
          </div>

          <div className="col-span-2 my-5 flex items-center justify-center md:my-10 lg:col-span-4 xl:my-20">
            <button
              className="start-button my-2 ml-4 w-1/2 px-4 py-2 text-lg font-bold md:py-3 md:text-xl lg:w-1/4 lg:text-2xl xl:text-3xl 2xl:text-4xl"
              onClick={navigateToStart}
            >
              Get Started!
            </button>
          </div>
        </div>
      </section>

      <div className="sticky top-0 z-20 mx-auto flex h-36 flex-col items-center justify-between bg-[#1E1E1E] p-4 px-24 lg:flex-row">
        <div className="flex  flex-row gap-x-8 text-[#CCCCC1]">
          <h1>© 2024 enjuggernaut</h1>
          <a href="/privacy.html">Privacy Policy</a>
        </div>
        <a className="flex flex-row gap-x-4" href={maillink}>
          <img src={mail} />
          <h1 className="text-[#CCCCC1]">Contact</h1>
        </a>
      </div>
    </div>
  );
}

export default Home;
